import React from "react";
import { Bell } from "lucide-react";
import { AnnouncementCard } from "./AnnouncementCard";
import { SystemAnnouncement } from "../../../../types/features/administration/SystemAnnouncement";

interface AnnouncementsListProps {
  announcements: SystemAnnouncement[];
  loading: boolean;
  onEdit: (announcement: SystemAnnouncement) => void;
  onDelete: (id: string) => void;
}

export const AnnouncementsList: React.FC<AnnouncementsListProps> = ({ announcements, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (announcements.length === 0) {
    return (
      <div className="text-center py-12">
        <Bell className="w-16 h-16 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600">Aucune annonce trouvée</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {announcements.map((announcement) => (
        <AnnouncementCard key={announcement.id} announcement={announcement} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </div>
  );
};
